import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Nav, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import eventival from '../../assets/images/integrations/eventival.png';
import mailchimp from '../../assets/images/integrations/mailchimp.png';
import wp from '../../assets/images/integrations/wp.png';

import "./QuickAccess.css"

const QuickAccess = () => {
    const { t } = useTranslation();

    const { setting } = useSelector(state => state.settings);

    if (!setting)
        return null;

    return (
        <div className="QuickAccess">
            <Nav navbar>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                        <i className="fa fa-external-link-square"></i>&nbsp;
                        {t('app.quick_access')}
                    </DropdownToggle>
                    <DropdownMenu right>
                        {setting.eshop?.uri && (
                            <>
                                <DropdownItem>
                                    <NavLink href={`${setting.eshop.uri}/user/login`} target="_blank" className="text-dark">
                                        <i className="fa fa-tag"></i>&nbsp;Ticketack
                                    </NavLink>
                                </DropdownItem>
                                <DropdownItem divider />
                            </>
                        )}
                        {setting.integrations?.eventival && (
                            <DropdownItem>
                                <NavLink href="https://bo.eventival.com" target="_blank" className="text-dark">
                                    <img src={eventival} className="img rounded" />
                                    &nbsp; {t('settings.integrations.eventival.title')}
                                </NavLink>
                            </DropdownItem>
                        )}
                        {setting.integrations?.wp?.websites?.map((w, index) => (
                            <DropdownItem key={index}>
                                <NavLink href={w.uri} target="_blank" className="text-dark">
                                    <img src={wp} className="img rounded" />
                                    &nbsp; {w.name}
                                </NavLink>
                            </DropdownItem>
                        ))}
                        {setting.integrations?.mailchimp && (
                            <DropdownItem>
                                <NavLink href="https://mailchimp.com" target="_blank" className="text-dark">
                                    <img src={mailchimp} className="img rounded" />
                                    &nbsp; {t('settings.integrations.mailchimp.title')}
                                </NavLink>
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Nav>
        </div>
    );
}

export default QuickAccess;
